import script from "./ActiveView.vue?vue&type=script&setup=true&lang=js"
export * from "./ActiveView.vue?vue&type=script&setup=true&lang=js"

import "./ActiveView.vue?vue&type=style&index=0&id=6a8870f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a8870f1"]])

export default __exports__